module.exports = __webpack_public_path__ + "static/media/gingerbread-man.b832ad9d.svg";